import { render, staticRenderFns } from "./FontAttrsItem.vue?vue&type=template&id=70617cc4&"
import script from "./FontAttrsItem.vue?vue&type=script&lang=js&"
export * from "./FontAttrsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70617cc4')) {
      api.createRecord('70617cc4', component.options)
    } else {
      api.reload('70617cc4', component.options)
    }
    module.hot.accept("./FontAttrsItem.vue?vue&type=template&id=70617cc4&", function () {
      api.rerender('70617cc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/attr/items/FontAttrsItem.vue"
export default component.exports